import React, { useState, useEffect } from 'react';
import { Loading } from 'react-admin';
import { Typography, Box, Card, CardContent } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import { apiUrl } from '../../utils/dataProvider';
import httpClient from '../../utils/httpClient';

const SimpleError = ({ error }) => (
  <Box mt={2} p={2} bgcolor="#fff9f9" border="1px solid #ffcdd2" borderRadius={4}>
    <Box display="flex" alignItems="center" mb={2}>
      <ErrorIcon style={{ color: '#f44336', marginRight: 8 }} />
      <Typography variant="h6" color="error">
        Алдаа гарлаа
      </Typography>
    </Box>
    <Typography variant="body1">
      {error.message || String(error)}
    </Typography>
  </Box>
);

const getStatus = (status) => {
  if (status === 'draft') {
    return "драфтласан";
  }
  if (status === 'comming_soon') {
    return "тун удахгүй";
  }
  return "нийтлэсэн";
}

const CreatorCourses = ({ creatorId }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [allCourses, setAllCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  
  // Filter courses by creator ID
  useEffect(() => {
    if (allCourses.length > 0 && creatorId) {
      const creatorIdNum = Number(creatorId);
      const filtered = allCourses.filter(course => 
        Number(course.creatorId) === creatorIdNum
      );
      setFilteredCourses(filtered);
    }
  }, [allCourses, creatorId]);
  
  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      
      try {
        const response = await httpClient(`${apiUrl}/skills/courses`);
        
        if (response && response.json) {
          setAllCourses(response.json);
          setError(null);
        } else {
          setError({
            message: "Хариу ирээгүй байна."
          });
        }
      } catch (err) {
        setError({
          message: "Хичээлүүдийг авах үед алдаа гарлаа."
        });
      } finally {
        setLoading(false);
      }
    };
    
    if (creatorId) {
      fetchCourses();
    }
  }, [creatorId]);
  
  if (loading) return <Loading />;
  
  if (error) {
    return <SimpleError error={error} />;
  }
  
  return (
    <Box mt={2}>
      <Typography variant="h6" gutterBottom>
        Хичээлүүд ({filteredCourses.length})
      </Typography>
      
      <Card>
        <CardContent>
          {filteredCourses.length === 0 ? (
            <Typography variant="body1">Хичээл олдсонгүй</Typography>
          ) : (
            <Box style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={tableHeaderStyle}>ID</th>
                    <th style={tableHeaderStyle}>Гарчиг</th>
                    <th style={tableHeaderStyle}>Статус</th>
                    <th style={tableHeaderStyle}>Үнэ</th>
                    <th style={tableHeaderStyle}>Үүсгэсэн огноо</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCourses.map(course => (
                    <tr key={course.id} style={tableRowStyle}>
                      <td style={tableCellStyle}>{course.id}</td>
                      <td style={tableCellStyle}>{course.title}</td>
                      <td style={tableCellStyle}>{getStatus(course.status)}</td>
                      <td style={tableCellStyle}>
                        {course.saledPrice ? (
                          <span>
                            <span style={{ textDecoration: 'line-through', color: '#999' }}>
                              {course.price}₮
                            </span>
                            {' '}
                            <strong>{course.saledPrice}₮</strong>
                          </span>
                        ) : (
                          `${course.price}₮`
                        )}
                      </td>
                      <td style={tableCellStyle}>
                        {new Date(course.createdAt).toLocaleDateString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

// Styles for the table
const tableHeaderStyle = {
  textAlign: 'left',
  padding: '12px 8px',
  borderBottom: '2px solid #e0e0e0',
  color: '#757575',
  fontWeight: 'bold',
};

const tableRowStyle = {
  borderBottom: '1px solid #e0e0e0',
};

const tableCellStyle = {
  padding: '12px 8px',
};

export default CreatorCourses; 